import { render, staticRenderFns } from "./Proyeccion.vue?vue&type=template&id=e8f44978&scoped=true"
import script from "./Proyeccion.vue?vue&type=script&lang=js"
export * from "./Proyeccion.vue?vue&type=script&lang=js"
import style0 from "./Proyeccion.vue?vue&type=style&index=0&id=e8f44978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f44978",
  null
  
)

export default component.exports